//sticky sidebar functionality
$(document).ready(function(){
	$('a.scroll-menu').click(function(){
	    $('html, body').animate({
	        scrollTop: $( $(this).attr('href') ).offset().top - 80
	    }, 500);
	    return false;
	});


    $(".sticky_header").stick_in_parent({
        offset_top: 0
    }).on("sticky_kit:bottom", function(e) {
        $(this).hide();
    }) .on("sticky_kit:unbottom", function(e) {
        $(this).show();
    });

    $(".sticky_column").stick_in_parent({
    });


    $('#sidebar-right').theiaStickySidebar({ });

	//$('#sidebar-right').height(function(){ return $(this).parent().height();});
	/*$('#sidebar-left').parent().height(function(){ return $(this).height();});

	$("#sidebar-right").stick_in_parent({recalc_every: 1});*/

});